/* Copyright (C) 2018 TeselaGen Biotechnology, Inc. */
import React from "react";
import { Spinner } from "@blueprintjs/core";
export default function AsyncValidateFieldSpinner(_ref) {
  var validating = _ref.validating;

  if (validating) {
    return /*#__PURE__*/React.createElement(Spinner, {
      size: "18"
    });
  } else {
    return null;
  }
}